<template>
  <div class="h-100" :class="{ 'app-kiosk-mode': isKioskRoute }" v-if="isShowLayout" @touchstart="onTouchStart" @touchmove="onTouchMove">
    <!-- <sidenav :custom_class="color" :class="[isRTL ? 'fixed-end' : 'fixed-start']" v-if="showSidenav" /> -->
    <main class="main-content position-relative overflow-x-hidden">
      <!-- nav -->
      <!-- <navbar :class="[isNavFixed ? navbarFixed : '', isAbsolute ? absolute : '']"
      :color="isAbsolute ? 'text-white opacity-8' : ''" :minNav="navbarMinimize" v-if="showNavbar" /> -->
      <router-view />
    </main>
    <KskPoweredBy v-if="isKioskRoute" :faded="$route.name === 'LandingPageKiosk'" />
  </div>
</template>
<script>
// import Sidenav from "./common/Sidenav";
// import Navbar from "@/common/Navbars/Navbar.vue";
import { mapState, mapActions } from "vuex";
// import $ from "jquery";
import axios from "axios";
import { gotoMemberLogin, localStorageName } from "@/config/utils";
import {
  QR_REDIRECT_LANDING_PAGE,
  QR_REDIRECT_LOGIN_PAGE,
  QR_REDIRECT_ORDERING_PAGE,
  QR_REDIRECT_MEMBER_PAGE,
} from "@/config/const";
import router from "@/router";
import { restoreLocale, restoreKioskLocale } from "@/i18n";
import { kioskColorVars, kioskBackground } from "@/config/kioskColorSlots";
import { isKioskPreview, startKioskPreview } from "@/views/kiosk/kioskPreview";
import KskPoweredBy from "@/views/kiosk/components/ui/KskPoweredBy.vue";

export default {
  name: "App",
  components: {
    KskPoweredBy,
    // Sidenav,
    // Navbar
  },
  data() {
    return {
      isShowLayout: false,
      touchStartX: 0,
      // M920: the route this page load actually started on. Cover.vue can push the
      // shopper to /order from its own (stale) localStorage copy of the branch before
      // /check-merchant-and-branch answers, so by then currentRoute may no longer say
      // "Cover" — and the QR setting would be skipped.
      entryRoute: { name: "", params: {} },
    };
  },
  mounted() {
    // KSK063: Minty's Kiosk Appearance page embeds the kiosk with ?ksk_preview=1.
    if (isKioskPreview()) startKioskPreview({ store: this.$store, router: this.$router });
    // if (window.innerWidth < 1200) {
    //   $(".icon-close-sidenav-main").show();
    // } else {
    //   $(".icon-close-sidenav-main").hide();
    // }

    if (["/404", "/page-expired"].includes(window.location.pathname)) {
      this.isShowLayout = true;
    } else {
      // Wait for the initial navigation (including async route guards like checkUrlExpiry)
      // to fully resolve before reading route params. Without this, router.currentRoute.value
      // still holds the START location (empty params) and table_code would be undefined.
      router.isReady().then(() => {
        // A route guard (checkKioskMode / checkUrlExpiry) may have already
        // redirected here before this resolves — on a hard navigation, that
        // redirect also wipes MERCHANT_CODE/BRANCH_CODE from localStorage
        // (beforeEach sets them from route params, and Error404/PageExpired
        // have none). Running checkMerchantAndBranch with those blanked-out
        // codes fails a second time and overwrites the guard's returnPath
        // with the dead-end /404 URL itself. Skip it — the guard already
        // decided this navigation's fate.
        const currentName = router.currentRoute.value.name;
        if (currentName === 'Error404' || currentName === 'PageExpired') {
          this.isShowLayout = true;
          return;
        }

        this.entryRoute = {
          name: currentName || "",
          params: { ...router.currentRoute.value.params },
        };

        const merchantCode = localStorage.getItem("MERCHANT_CODE") || "";
        const branchCode = localStorage.getItem("BRANCH_CODE") || "";
        this.checkMerchantAndBranch(merchantCode, branchCode);
      });
    }
  },
  watch: {
    // App.vue's mounted() only runs checkMerchantAndBranch once, so re-scanning a
    // different merchant/branch QR code without a full page reload (component reuse
    // on param-only navigation) left the store/MERCHANT_ID stuck on the old merchant.
    // Re-run validation whenever the resolved merchant/branch actually changes.
    '$route'(to, from) {
      // The initial navigation is already handled by mounted()'s router.isReady() flow.
      if (!from.name) return;

      const merchantCode = to.params.merchant_code;
      const branchCode = to.params.branch_code;
      if (!merchantCode) return;
      if (merchantCode === from.params.merchant_code && branchCode === from.params.branch_code) {
        return;
      }
      if (['Error404', 'PageExpired'].includes(to.name)) return;

      this.checkMerchantAndBranch(merchantCode, branchCode);
    },
    // KSK001: kiosk theme-2 tokens (assets/css/kiosk-theme2.css) read the merchant
    // colour from --ksk-brand. Written on <html> so kiosk modals teleported to
    // <body> get it too; nothing outside the kiosk root reads --ksk-*.
    kioskBrandColor: {
      immediate: true,
      handler(brand) {
        const root = document.documentElement.style;
        // `ksk-active` scopes the kiosk scrim colour onto Bootstrap's
        // .modal-backdrop, which lives on <body> outside .app-kiosk-mode.
        document.documentElement.classList.toggle("ksk-active", !!brand);
        if (!brand) {
          root.removeProperty("--ksk-brand");
          root.removeProperty("--ksk-on-brand");
          return;
        }
        root.setProperty("--ksk-brand", brand);
        root.setProperty("--ksk-on-brand", this.readableOn(brand));
      },
    },
    // KSK063: on <html> like --ksk-brand, so teleported modals see them too.
    kioskColorVars: {
      immediate: true,
      handler(vars, old) {
        const root = document.documentElement.style;
        Object.keys(old || {}).forEach((name) => {
          if (!(name in vars)) root.removeProperty(name);
        });
        Object.keys(vars).forEach((name) => root.setProperty(name, vars[name]));
      },
    },
    // KSK105: tinted kiosk background; unset → the theme's own surface/canvas.
    kioskBackground: {
      immediate: true,
      handler(background) {
        const root = document.documentElement.style;
        document.documentElement.classList.toggle("ksk-tinted", !!background);
        if (background) root.setProperty("--ksk-tint-bg", background);
        else root.removeProperty("--ksk-tint-bg");
      },
    },
    // KSK040: kiosk theme 2 is drawn in fixed px on a 1080×1920 canvas. Kiosks
    // whose browser reports a smaller CSS viewport (display scaling / DPR)
    // clipped it, so while a kiosk route is open the whole page is zoomed by
    // viewport width / 1080: always full width, proportions kept, any screen.
    isKioskRoute: {
      immediate: true,
      handler(isKiosk) {
        window.removeEventListener("resize", this.applyKioskScale);
        if (isKiosk) window.addEventListener("resize", this.applyKioskScale);
        this.applyKioskScale();
      },
    },
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.applyKioskScale);
  },
  methods: {
    applyKioskScale() {
      const html = document.documentElement;
      // Kiosk is a portrait tablet. A screen wider than 3:4 (desktop browser,
      // landscape) gets a tablet-width column centred with empty sides
      // (`ksk-framed`, kiosk-theme2.css) instead of a canvas zoomed to fill it.
      const frameWidth = Math.min(window.innerWidth, window.innerHeight * 0.75);
      const framed = this.isKioskRoute && window.innerWidth - frameWidth >= 1;
      const scale = this.isKioskRoute ? frameWidth / 1080 : 1;
      const scaled = Math.abs(scale - 1) >= 0.01;
      // Under zoom, vh/vw and media queries still follow the real screen, so
      // kiosk CSS reads --ksk-vh and `ksk-scaled` (kiosk-theme2.css) instead.
      html.classList.toggle("ksk-scaled", scaled);
      html.classList.toggle("ksk-framed", framed);
      if (scaled) {
        html.style.zoom = scale.toFixed(4);
        html.style.setProperty("--ksk-vh", `${window.innerHeight / scale / 100}px`);
      } else {
        html.style.removeProperty("zoom");
        html.style.removeProperty("--ksk-vh");
      }
    },
    // Black or white, whichever reads better on the given #rrggbb background.
    readableOn(hex) {
      const m = /^#?([0-9a-f]{6})$/i.exec(String(hex).trim());
      if (!m) return "#ffffff";
      const n = parseInt(m[1], 16);
      const lin = (c) => {
        c /= 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
      };
      const l = 0.2126 * lin((n >> 16) & 255) + 0.7152 * lin((n >> 8) & 255) + 0.0722 * lin(n & 255);
      return l > 0.4 ? "#141a14" : "#ffffff";
    },
    ...mapActions(["setColor", "setTheme2", "setKioskColors", "setKioskCardColor", "setMerchantCode", "setBranchCode", "setError"]),
    checkMerchantAndBranch(merchantCode, branchCode) {

      if (router.currentRoute.value.name === "PhysicalBranches") {
        this.isShowLayout = true;
        return;
      }
      const physicalBranchId = router.currentRoute.value.params.physical_branch_id ?? 0;
      var dataForm = {};

      if (physicalBranchId) {
        dataForm = {
          physical_branch_id: physicalBranchId,
        };
      } else {
        dataForm = {
          branch_code: branchCode,
        };
      }

      this.isShowLayout = false;
      axios
        .post(
          process.env.VUE_APP_BASE_URL + "/check-merchant-and-branch", dataForm,
          {
            headers: {
              MerchantCode: merchantCode,
            },
          }
        )
        .then(
          async (response) => {
            var dataResponse = response.data;
            if (dataResponse.result.isSuccess) {
              await this.setColor(dataResponse.data.moo_color ?? "#f9dd4b");
              await this.setTheme2({
                logo: dataResponse.data.logo_theme2 ?? "",
                mainColor: dataResponse.data.main_theme2_color ?? "",
                buttonColor: dataResponse.data.primary_button_theme2_color ?? "",
              });
              await this.setKioskColors(dataResponse.data.branch_info?.kiosk_custom_colors ?? null);
              await this.setKioskCardColor(dataResponse.data.branch_info?.kiosk_card_color ?? null);
              await this.setMerchantCode(merchantCode);
              await this.setBranchCode(branchCode);
              // The locale is persisted under a merchant+branch-namespaced key,
              // so it can only be restored once both codes are in the store.
              if (window.location.pathname.includes("/kiosk")) {
                restoreKioskLocale();
              } else {
                restoreLocale();
              }
              localStorage.setItem(
                localStorageName("MERCHANT_ID"),
                dataResponse.data.merchant_id ?? 0
              );
              localStorage.setItem(
                localStorageName("MERCHANT_BRAND_NAME"),
                dataResponse.data.merchant_brand_name ?? ""
              );
              localStorage.setItem(
                localStorageName("BRANCH_INFO"),
                dataResponse.data.branch_info
                  ? JSON.stringify(dataResponse.data.branch_info)
                  : ""
              );
              localStorage.setItem(
                localStorageName("KIOSK_MODE"),
                dataResponse.data.branch_info
                  ? dataResponse.data.branch_info.enable_retail_mode
                  : 0
              );
              localStorage.setItem(
                localStorageName("MERCHANT_LOGO"),
                dataResponse.data.merchant_logo ?? ""
              );
              localStorage.setItem(
                localStorageName("MERCHANT_LOGO"),
                dataResponse.data.merchant_logo ?? ""
              );
              localStorage.setItem(
                localStorageName("DISPLAY_SPECIAL_REQUEST_IN_POS"),
                dataResponse.data.data_merchant_setting
                  .display_special_request_in_pos ?? ""
              );
              localStorage.setItem(
                localStorageName("ALLOW_PAYMENT_BY_MINTY_WALLET"),
                dataResponse.data.data_merchant_setting
                  .allow_payment_by_minty_wallet ?? ""
              );
              localStorage.setItem(
                localStorageName("ALLOW_SHOW_APPLY_VOUCHER"),
                dataResponse.data.data_merchant_setting
                  .allow_show_apply_voucher ?? 1
              );
              localStorage.setItem(
                localStorageName("DEFAULT_PAYMENT_METHOD_NAME"),
                dataResponse.data.data_merchant_setting
                  .default_payment_method_name ?? 'Credit/Debit Card'
              );
              localStorage.setItem(
                localStorageName("ONLY_ALLOW_EXISTING_MEMBER_MOO_LOGIN"),
                dataResponse.data.data_merchant_setting
                  .only_allow_existing_member_moo_login ?? 'false'
              );

              var branchInfo = dataResponse.data.branch_info;
              var memberInfo = JSON.parse(
                localStorage.getItem(localStorageName("memberInfo"), "")
              );

              if (router.currentRoute.value.name == 'Cover') {
                const tableCode = router.currentRoute.value.params.table_code;
                const isScanQR =  router.currentRoute.value.query.scan ?? false;

                if (tableCode && isScanQR) {
                  const cartName = await this.$store.dispatch('cartName');
                  const cartNameQueue = await this.$store.dispatch('cartName', 'ORDER_QUEUE_INFO_');

                  let itemSelect = JSON.parse(localStorage.getItem(cartName, [])) ?? [];
                  let itemQueueSelect = JSON.parse(localStorage.getItem(cartNameQueue, []));

                  if (itemQueueSelect) {
                    itemSelect.push(...itemQueueSelect);
                    localStorage.setItem(cartName, JSON.stringify(itemSelect));
                    localStorage.removeItem(cartNameQueue);
                  }
                }
                
              }

              const urlParams = new URLSearchParams(window.location.search);
              const isGuestQuery = urlParams.get('guest') == '1';
              if (isGuestQuery) {
                localStorage.setItem(localStorageName("GUEST_MODE"), "1");
                // Only strip the guest param once the router has resolved the route,
                // otherwise replace() would navigate to an undefined route name
                if (router.currentRoute.value.name) {
                  const newQuery = { ...router.currentRoute.value.query };
                  delete newQuery.guest;
                  router.replace({
                    name: router.currentRoute.value.name,
                    params: router.currentRoute.value.params,
                    query: newQuery,
                  });
                }
              }

              const isGuestStored = localStorage.getItem(localStorageName("GUEST_MODE")) == "1";
              const currentRouteName = router.currentRoute.value.name || "";
              // Check the pathname too: kiosk routes await checkKioskMode's API call,
              // so the route may not be resolved yet when this response arrives
              const isKioskRoute = currentRouteName.includes("Kiosk") || window.location.pathname.includes("/kiosk");
              // A customer landing here already paid — often via an off-site gateway
              // redirect (AllInPay/Stripe) that can come back without the browser's
              // memberInfo/session intact, or on a different device/tab than checkout.
              // Login Required must not block them from seeing their own confirmation.
              const isPaymentSuccessRoute = currentRouteName === "PaymentSuccess";

              // M920: the URL inside an already-printed QR can never change, so the
              // branch setting decides here — on the Cover page every scan lands on —
              // where the shopper actually goes. This runs once per page load with
              // branch_info fresh from the API; Cover.vue's own copy comes from
              // localStorage and is empty on a first-ever scan of this device.
              //
              // The setting governs a scan whether or not the shopper is signed in, so
              // Login Required does not intercept this path: a merchant who points a QR
              // at a page means that page. Shoppers arriving through a plain MOO link
              // still meet the Login Required gate below.
              // SH001: a salon branch always starts on its own landing (the location
              // picker Cover.vue renders). Neither the QR redirect setting nor Login
              // Required may divert that — signing in belongs to a later salon step.
              const isSalonTheme = Number(branchInfo.salon_theme) === 1;

              const hasQrSetting =
                branchInfo.moo_qr_redirect_page !== undefined &&
                branchInfo.moo_qr_redirect_page !== null &&
                branchInfo.moo_qr_redirect_page !== "";
              const isQrScanEntry =
                hasQrSetting &&
                this.entryRoute.name === "Cover" &&
                String(this.entryRoute.params.type || "").toUpperCase() === "QR";
              const qrRedirectTarget = isQrScanEntry
                ? this.qrRedirectRouteName(branchInfo, memberInfo)
                : "";
              // ?key= / ?token= are member-site login hand-offs; Cover.vue logs the
              // shopper in and routes them itself, so stay out of its way.
              const hasLoginHandoff = !!(
                router.currentRoute.value.query.key ||
                router.currentRoute.value.query.token ||
                urlParams.get("key") ||
                urlParams.get("token")
              );

              if (isSalonTheme) {
                // stay on the salon landing
              } else if (isQrScanEntry && !hasLoginHandoff) {
                if (qrRedirectTarget === "SignIn") {
                  gotoMemberLogin('Order', false, 'login');
                } else if (qrRedirectTarget) {
                  router.push({
                    name: qrRedirectTarget,
                    params: this.entryRoute.params,
                  });
                }
                // An empty target is the Landing Page option: the shopper stays here.
              } else if (
                branchInfo.login_required &&
                branchInfo.hide_member_login_moo != 1 &&
                !memberInfo &&
                !isGuestQuery &&
                !isGuestStored &&
                !isKioskRoute &&
                !isPaymentSuccessRoute &&
                !router.currentRoute.value.query.key &&
                !urlParams.get('key')
              ) {
                gotoMemberLogin('Order', false, 'login');
              }

              this.isShowLayout = true;
            }
          },
          (error) => {
            const result = error.response?.data?.result;
            this.setError({
              statusCode: result?.statusCode ?? error.response?.status,
              message: result?.message,
              // No HTTP response at all (network drop, timeout, CORS) means
              // this isn't a genuine "not found" — worth letting the shopper
              // retry instead of a dead-end error.
              retryable: !error.response,
              // Error404's retry button needs the original URL: merchant_code/
              // branch_code live only in the path, and both the route params
              // and the localStorage copy get wiped once we're on /404.
              returnPath: router.currentRoute.value.fullPath,
            });
            this.isShowLayout = true;
            router.push({ name: "Error404" });
          }
        );
    },
    // M920: the MOO route a scanned table QR should open, per the branch setting.
    // An empty string means "leave the shopper on the landing page" — today's behaviour,
    // and what every branch gets until a merchant picks something else.
    qrRedirectRouteName(branchInfo, memberInfo) {
      const setting = Number(branchInfo.moo_qr_redirect_page) || QR_REDIRECT_LANDING_PAGE;

      // M1051: with member Login and Rewards hidden, the login / member page
      // targets open the ordering page instead.
      if (branchInfo.hide_member_login_moo == 1
        && (setting === QR_REDIRECT_LOGIN_PAGE || setting === QR_REDIRECT_MEMBER_PAGE)) {
        return "Order";
      }

      switch (setting) {
        case QR_REDIRECT_LOGIN_PAGE:
          // A member who is already signed in has nothing to do on the login screen.
          return memberInfo ? "Order" : "SignIn";
        case QR_REDIRECT_ORDERING_PAGE:
          return "Order";
        case QR_REDIRECT_MEMBER_PAGE:
          return "Profile";
        default:
          return "";
      }
    },

    onTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
    },
    onTouchMove(event) {
      if (router.currentRoute.value.name.includes("Kiosk")) {
        const touchCurrentX = event.touches[0].clientX;
        const deltaX = touchCurrentX - this.touchStartX;

        if (Math.abs(deltaX) > 10) { // Adjust threshold as needed
          event.preventDefault(); // Prevent swipe navigation
        }
      }
    },
  },
  computed: {
    ...mapState([
      "isRTL",
      "color",
      "isAbsolute",
      "isNavFixed",
      "navbarFixed",
      "absolute",
      "showSidenav",
      "showNavbar",
      "showFooter",
      "showConfig",
      "hideConfigButton",
    ]),
    isKioskRoute() {
      return this.$route.path.includes("/kiosk") || this.isKioskErrorPage;
    },
    // /404 reached from a kiosk URL: show it as a kiosk screen (zoom, tablet
    // frame, kiosk theme) rather than the MOO error page.
    isKioskErrorPage() {
      const returnPath = this.$store.state.error?.returnPath || "";
      return this.$route.name === "Error404" && returnPath.includes("/kiosk");
    },
    kioskBrandColor() {
      if (!this.isKioskRoute) return null;
      // On the error page the merchant may never have loaded; the store's
      // MOO default yellow then falls back to the kiosk theme colour.
      if (this.isKioskErrorPage && this.color === "#f9dd4b") return null;
      return this.color;
    },
    // KSK063: --ksk-c-<slot>-<part> for every customised kiosk element.
    kioskColorVars() {
      return this.isKioskRoute ? kioskColorVars(this.$store.state.kioskColors) : {};
    },
    kioskBackground() {
      return this.isKioskRoute ? kioskBackground(this.$store.state.kioskCardColor) : null;
    },
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";

    const sidenav = document.getElementsByClassName("g-sidenav-show")[0];

    if (window.innerWidth > 1200) {
      sidenav.classList.add("g-sidenav-pinned");
    }
  },
};
</script>

<style scoped>
.main-content {
  background: #ffffff;
  overflow-y: auto !important;
  min-height: 100%;
  max-height: 100%;
  height: 100%;
  /* Hide the right scrollbar app-wide (scrolling still works). Order /
     Category / Kiosk Checkout already hide it on their own inner scroll
     container; pages without one (e.g. Order Confirmed) scroll here instead,
     so the bar has to be hidden at this level for them. */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE / old Edge */
}

.main-content::-webkit-scrollbar {
  display: none; /* Chrome / Safari */
  width: 0;
  height: 0;
}
</style>
